// extracted by mini-css-extract-plugin
export default {"LandscapeOverly":"LandscapeOverly_LandscapeOverly__HOwBQ","LandscapeOverlyBoxTextImage":"LandscapeOverly_LandscapeOverlyBoxTextImage__v5SDo"};